import 'core-js/fn/string/includes';
import $ from 'jquery';
import loadFrontend, { initFrontend } from '@cigna/cigna_digital_dcws_cigna-frontend/src/js/';
import { isExternal, setExternalLinkChecker } from '@cigna/cigna_digital_dcws_cigna-frontend/src/js/links';
import { cookie } from '@cigna/cigna_digital_dcws_cigna-frontend/src/js/util/storage';
import initTools from './tools'; // import navigation from './components/navigation';

import initOnboardingPage from './pages/mycigna-onboarding';
import updateContent from './individuals-families/csbsearchlp/micro/content-controller';

var isExternalLink = function isExternalLink(link, href, hostname) {
  var externalUrlWhiteList = ['my.cigna', 'mycigna', 'www.cigna', '.cigna'];
  var isExternalDefault = isExternal(link, href, hostname); // Return false if part of the white list array.

  if (externalUrlWhiteList.some(function (val) {
    return hostname.includes(val);
  })) return false;
  return isExternalDefault && !hostname.includes('.cigna.com'); // not a cigna.com host
};

var init = function init(err) {
  if (location.pathname === '/' && cookie.get('OEP_li', false)) {
    $('.hero-white-left-box.mycigna-OEP_li-hero').show();
  } else {
    $('.hero-white-left-box.cigna-original-hero').show();
  }

  setExternalLinkChecker(isExternalLink);
  initFrontend(err);
  cookie.remove('hwheader');
  initTools();
};

$(function () {
  initOnboardingPage();
  loadFrontend(init);
  updateContent();
});